import { PillStatusConfig } from "src/app/components/status-pill/status-pill.component";
import { StatusData } from "src/app/constants/Status";
import { TaskStatusConfig } from "src/app/constants/status-pill-configs";

export interface DbExport {
  id: number;
  date: Date;
  status: number;
  isDeleted?: boolean;
}

export enum DatabaseExportStatusEnum {
  COMPLETE = 0,
  FAILED = 1,
  IN_PROGRESS = 2,
  WAITING = 3,
}

/** Same badge look as the task statuses (task list, project status, contract deadlines) - #1052.
 *  Only the label differs; colours come from TaskStatusConfig so the two can't drift apart. */
const badgeLike = (taskStatusId: number, id: DatabaseExportStatusEnum, status: string): PillStatusConfig => ({
  ...TaskStatusConfig.find((c) => c.id === taskStatusId)!,
  id,
  status,
});

export const DatabaseExportStatusConfig: PillStatusConfig[] = [
  badgeLike(StatusData.DONE.id, DatabaseExportStatusEnum.COMPLETE, $localize`:@@downloadAvailable:Download Available`),
  badgeLike(StatusData.REJECTED.id, DatabaseExportStatusEnum.FAILED, $localize`:@@failed:Failed`),
  badgeLike(StatusData.IN_PROGRESS.id, DatabaseExportStatusEnum.IN_PROGRESS, $localize`:@@inProgress:In Progress`),
  badgeLike(StatusData.OPEN.id, DatabaseExportStatusEnum.WAITING, $localize`:@@waiting:Waiting`),
];
